import { DishDto, DishPortionItemDto, type DishPortionPriceDto } from '@/api/generated';
import {
  DishUnitOptionsTranslation,
  dishUnitTypesOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { DishPortionAddModel } from '@/views/dishes/details/components/header/components/dialog/model/DishPortionAdd.model.ts';
import { DishPortionsSearchFormModel } from '@/views/dishes/details/components/portions/model/DishPortionsSearchForm.model.ts';

export type DishDetailsViewTranslation = {
  dialog: {
    addPortion: {
      button: {
        cancel: string;
        save: string;
        saveAndAdd: string;
      };
      dishUnitTypesOptions: DishUnitOptionsTranslation;
      editHint: string;
      form: Record<keyof DishPortionAddModel, string>;
      titleAdd: string;
      titleUpdate: string;
    };
  };
  header: {
    button: {
      addPortion: string;
      disable: string;
      edit: string;
      enable: string;
    };
  };
  main: Record<keyof Omit<DishDto, 'dishId' | 'measurement' | 'name'>, string> & {
    dishUnitOptions: DishUnitOptionsTranslation;
    quantity: string;
  };
  portions: {
    table: {
      body: { statusOff: string; statusOn: string } & Record<
        keyof Omit<DishPortionItemDto, 'dishId' | 'dishPortionId' | 'price'>,
        string
      > &
        Record<keyof DishPortionPriceDto, string>;
      head: Record<keyof DishPortionsSearchFormModel, string>;
    };
  };
};

export const dishDetailsViewTranslation: DishDetailsViewTranslation = {
  dialog: {
    addPortion: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
        saveAndAdd: 'Zapisz i dodaj kolejne',
      },
      dishUnitTypesOptions: dishUnitTypesOptionsTranslation,
      editHint:
        'W zapisanym okresie zmienisz tylko daty i aktywność. Inne kwoty: dodaj nowy okres (Dodaj porcję) i wyłącz ten.',
      form: {
        active: 'Aktywne',
        foodCost: 'FoodCost',
        minimumSalePrice: 'Minimalna cena sprzedaży',
        orderMinimumPortions: 'Minimalna liczba porcji',
        outOfDatePriceMultiplier: 'Mnożnik ceny po terminie',
        quantity: 'Porcja',
        suggestedSalePrice: 'Sugerowana cena sprzedaży',
        unit: 'Jednostka miary',
        validFrom: 'Ważne od',
        validTo: 'Ważne do',
      },
      titleAdd: 'Dodaj porcję',
      titleUpdate: 'Zaktualizuj porcję',
    },
  },
  header: {
    button: {
      addPortion: 'Dodaj porcję',
      disable: 'Wyłącz',
      edit: 'Edytuj',
      enable: 'Włącz',
    },
  },
  main: {
    active: 'Dostępny',
    category: 'Kategoria',
    department: 'Dział',
    description: 'Opis / dodatki w cenie',
    dietaryPreferences: 'Preferencje żywieniowe',
    dishUnitOptions: dishUnitTypesOptionsTranslation,
    quantity: 'Gramatura',
    seasonality: 'Sezonowość',
    tags: 'Tagi',
    type: 'Rodzaj dania',
  },
  portions: {
    table: {
      body: {
        active: 'Status',
        foodCost: 'FC',
        minimumSalePrice: 'Minimalna cena sprzedaży',
        orderMinimumPortions: 'Min. zamówienie',
        outOfDatePriceMultiplier: 'Mnożnik ceny po terminie',
        statusOff: 'Wyłączony',
        statusOn: 'Aktywny',
        suggestedSalePrice: 'Sugerowana cena sprzedaży',
        validFrom: 'Ważne od',
        validTo: 'Ważne do',
      },
      head: {
        validFrom: 'Ważne od',
        validTo: 'Ważne do',
      },
    },
  },
};
